<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="form">
                <div class=row *ngIf="disaplayType=='rejectcommand'||disaplayType=='addnotes'">
                    <div class="col-sm-12 col-xl-12 mt-2">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                            style="border-radius: 0 !important;">
                            <mat-label>Comments</mat-label>
                            <textarea rows="3" matInput type="text" placeholder="Enter Commnets"
                                formControlName="comment" autocomplete="off" specialIsAlphaNumeric
                                class="col-12 pl-2"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 align-self-center mt-4 ml-2" style=" align-items: center;"
                        *ngIf="this.data?.data?.serviceProviderId=='36'||this.data?.data?.serviceProviderId=='24'">
                        <div style="margin-right: 30px; font-size: large; text-align: center;">Are you rejecting this
                            application due to low creditVet</div>
                        <mat-radio-group formControlName="creditvetreason" class="justify-content-center mt-2 mr-4"
                            style="display: flex !important; flex-direction: row;">
                            <mat-radio-button value=true>Yes</mat-radio-button>
                            <mat-radio-button class="ml-3" value=false>No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="text-danger mt-2 col-12" *ngIf="show && !this.form.value.creditvetreason"
                        style="text-align: center;">
                        Please select an option.
                    </div>
                    <div class="col-xl-12  mt-3 d-flex justify-content-end button-style">
                        <button class="btn btn-secondary mr-3" (click)="Submit()">
                            Submit
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            Cancel
                        </button>
                    </div>
                </div>
                <div class="table-responsive mt-2 mb-4" *ngIf="disaplayType=='history'">
                    <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                        <ng-container matColumnDef="UpdatedOn">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="UpdatedOn">Updated On</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign"> {{dataField.creationTs|date:'dd-MMM-YYYY hh:mma'}}
                                </p>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Status">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">{{dataField.lineItemStatusName}}</p>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="DoneBy">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="DoneBy">Done By</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">{{dataField.updatedBy}} </p>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                        </mat-row>
                    </mat-table>

                </div>
                <ng-container *ngIf="disaplayType=='shippment'">
                    <div class="container my-4">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar">Device Details</span>
                            </div>
                        </div>
                        <div class="row mt-3" *ngIf="!isConsolidate">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Serial NO</mat-label>
                                    <input matInput maxlength="25" type="text" formControlName="serial"
                                        placeholder="Enter Naming Convention" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-xl-6 mt-2">
                                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                                    style="border-radius: 0 !important;">
                                    <mat-label>Comments</mat-label>
                                    <textarea rows="3" matInput type="text" placeholder="Enter Customer"
                                        formControlName="deviceComments" autocomplete="off" specialIsAlphaNumeric
                                        class="col-12 pl-2" cityId></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="table-responsive mt-2 mb-4" *ngIf="isConsolidate">
                            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                                <ng-container matColumnDef="LineItem">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="LineItem">Line
                                        Item</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.lineItemNumber}}
                                        </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="ProductName">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="ProductName">Product
                                        Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.productname}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="SerialNo">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="SerialNo">Serial
                                        No</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField; let i=index">
                                        <div class="col-10">
                                            <mat-form-field appearance="fill" hideRequiredMarker>
                                                <mat-label>Serial NO</mat-label>
                                                <input matInput maxlength="25" [formControl]="availableControls[i]"
                                                    placeholder="Enter Naming Convention" class="col-10"
                                                    autocomplete="off" cityId>
                                            </mat-form-field>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns1; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns1;" matRipple>
                                </mat-row>
                            </mat-table>

                        </div>
                    </div>

                    <div class="container my-4">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar">Courier Details</span>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Courier</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="courierId"
                                        placeholder="Select Application Number">
                                        <mat-select-filter [displayMember]="'value'" [array]="CourierList"
                                            (filteredReturn)="CourierList = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of CourierList" [value]="item.id"
                                            style="overflow-y: scroll !important;">
                                            {{item.courierName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Account NO</mat-label>
                                    <input matInput maxlength="25" formControlName="accountNumber"
                                        placeholder="Enter Naming Convention" class="col-10" autocomplete="off"
                                        readonly>
                                </mat-form-field>
                            </div>
                        </div>
                        <div calss="row mt-2">
                            <div class="col-sm-12 col-xl-6 mt-3 p-0">
                                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                                    style="border-radius: 0 !important;">
                                    <mat-label>Comments</mat-label>
                                    <textarea rows="3" matInput type="text" placeholder="Enter Customer"
                                        formControlName="courierComments" autocomplete="off" specialIsAlphaNumeric
                                        class="col-12 pl-2" cityId></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-xl-12 mt-3 d-flex justify-content-between button-style">
                            <button class="btn btn-primary" (click)="amendAddres()">
                                Amend Address
                            </button>
                            <div>
                                <button class="btn btn-secondary mr-3" (click)="print()">
                                    Print
                                </button>
                                <button class="btn btn-primary" (click)="saveShipmentForm()" [disabled]="disablePrint">
                                    Submit
                                </button>
                            </div>
                        </div>


                    </div>
                </ng-container>
                <ng-container *ngIf="disaplayType=='address'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Address Line 1</mat-label>
                                <input matInput maxlength="25" formControlName="addressLine1" class="col-10"
                                    autocomplete="off" cityId>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Address Line 2</mat-label>
                                <input matInput maxlength="25" formControlName="addressLine2" class="col-10"
                                    autocomplete="off" cityId>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Province</mat-label>
                                <mat-select class="scrollbarcs" formControlName="region"
                                    placeholder="Select Application Number" (selectionChange)="regionchange()">
                                    <mat-select-filter [displayMember]="'value'" [array]="value[1]"
                                        (filteredReturn)="filteredList1= $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>City</mat-label>
                                <mat-select class="scrollbarcs" formControlName="cityId"
                                    placeholder="Select Application Number ">
                                    <mat-select-filter [displayMember]="'value'" [array]="value[0]"
                                        (filteredReturn)="filteredList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Country</mat-label>
                                <mat-select class="scrollbarcs" formControlName="country"
                                    placeholder="Select Application Number ">
                                    <mat-select-filter [displayMember]="'value'" [array]="value[2]"
                                        (filteredReturn)="value[2] = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of value[2]" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>PinCode</mat-label>
                                <input matInput maxlength="6" formControlName="pincode" class="col-10"
                                    autocomplete="off" cityId>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-xl-12  mt-3 d-flex justify-content-end button-style">
                        <button class="btn btn-primary mr-3" (click)="saveCustomerDetailsForm()">
                            Submit
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="disaplayType=='rates'">
                    <div class="card my-3 p-4" (click)="selected(value.code)"
                        style="border-radius: 8px; cursor: pointer;"
                        [ngStyle]="{ 'background': selectedCardCode === value.code ? '#7e32dd' : '#F3F4FF' , 'color': selectedCardCode === value.code ? '#fff' : '#7e32dd' }"
                        *ngFor="let value of shipLogicGettingratesList">

                        <div class="row">
                            <div class="col-sm-12 col-md-12 text-center">
                                <p class="mb-2" style="font-size: 20px; font-weight: bold;">{{value.name}}</p>
                                <p class="mb-2" style="font-size: 15px; font-weight: bold;">{{value.description}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12  mt-3 d-flex justify-content-end button-style">
                        <button class="btn btn-secondary mr-3" (click)="ratesSubmit()">
                            Yes
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            No
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="disaplayType=='transferapprove'">
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Customer Request Date</mat-label>
                                <input readonly matInput formControlName="requestedDate" autocomplete="off"
                                    placeholder="Select From Date" class="custom-input-border">
                                <mat-datepicker-toggle matSuffix style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Admin Approval Date</mat-label>
                                <input  matInput appInputtext formControlName="adminapprovedate" [min]="mindate"
                                (click)="startDatePicker.open()" autocomplete="off" placeholder="Select From Date" class="custom-input-border">
                                <mat-datepicker-toggle matSuffix style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div> -->
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Admin Approval Date</mat-label>
                                <input matInput [matDatepicker]="startDatePicker" formControlName="adminapprovedate"
                                    autocomplete="off" placeholder="Select Connection Date" class="custom-input-border"
                                    (click)="startDatePicker.open()" [min]="mindate">
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-12  mt-3 d-flex justify-content-end button-style">
                            <button class="btn btn-secondary mr-3" (click)="transferapproveSubmit()">
                                Yes
                            </button>
                            <button class="btn btn-primary" (click)="Close()">
                                No
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="disaplayType=='transferdoc'">

                    <div class="table-responsive mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                            <ng-container matColumnDef="Type">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="Type">Type</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <p class="text-truncate txtalign"> {{dataField.documentTypeString}}</p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Date">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="Date">Date</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <p class="text-truncate txtalign">{{dataField.uploadedDate}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="FileName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="FileName">FileName</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <p class="text-truncate txtalign">{{dataField.fileName}} </p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                                <mat-cell *matCellDef="let dataField">
                                    <div class="text-truncate text-center">
                                        <button class="btn reset_btn mr-3" *ngIf="!dataField.action"
                                            (click)="Removefile(dataField)">
                                            Remove
                                        </button>
                                        <button class="btn btn-primary mr-3" *ngIf="dataField.action"
                                            (click)="selectfile(dataField)">
                                            Browse
                                        </button>

                                    </div>
                                </mat-cell>

                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns2; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumns2;" matRipple>
                            </mat-row>
                        </mat-table>
                    </div>
                    <div class="row">
                        <div class="col d-flex justify-content-end mr-3">
                            <button class="btn btn-primary" [disabled]="enableuploadbtn" (click)="upload()">
                                Upload
                            </button>
                        </div>
                    </div>

                </ng-container>

                    <div class="row mt-3 justify-content-center" *ngIf="disaplayType == 'eftDocs'">
                        <div class="col-12 text-center mb-4" style="font-size: 16px;">
                            Click the upload button to attach the EFT proof of payment (optional).
                        </div>
                        <div class="col-12 mb-2 d-flex justify-content-center">
                            <div class="file-container">
                                <mat-form-field appearance="fill" class="file-input">
                                    <mat-label>EFT Document</mat-label>
                                    <input matInput [value]="fileName" readonly  placeholder="Select Attachment"/>
                                </mat-form-field>

                                <input type="file" accept=".jpg,.jpeg,.pdf" (change)="onFileSelected($event)" #fileInput hidden />

                                <button type="button" (click)="fileInput.click()" *ngIf="!isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;" />
                                </button>

                                <button type="button" (click)="reset()" *ngIf="isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img style="filter: invert(1);width: 26px;"
                                        src="../../../../assets/Home-Connect/icons/delete.svg" />
                                </button>
                            </div>
                        </div>

                        <div class="col-12 d-flex justify-content-center mt-3 gap-3 flex-wrap">
                            <button class="btn btn-secondary mr-3" (click)="uploadEFT()">
                                Confirm Payment
                            </button>

                            <button class="btn btn-primary" (click)="Close()">
                                Cancel
                            </button>
                        </div>
                    </div>

                    <div calss="row" *ngIf="disaplayType=='Confirmation'">
                    <div class="col-xl-12 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Cancellation effective date</mat-label>
                            <input matInput [matDatepicker]="cancelDatePicker" formControlName="cancelDate"
                                autocomplete="off" placeholder="Select Connection Date" class="custom-input-border"
                                (click)="cancelDatePicker.open()" [min]="mindate">
                            <mat-datepicker-toggle matSuffix [for]="cancelDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #cancelDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-12  mt-4 d-flex justify-content-center button-style">
                        <button class="btn btn-secondary mr-3" (click)="canceldate()">
                            ok
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            close
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="disaplayType=='addresschange'">
                    <form [formGroup]="changeaddressforn">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Address Line 1</mat-label>
                                    <input matInput maxlength="25" formControlName="addressLine1" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Address Line 2</mat-label>
                                    <input matInput maxlength="25" formControlName="addressLine2" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Suburb</mat-label>
                                    <input matInput maxlength="26" formControlName="suburb" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>City</mat-label>
                                    <input matInput maxlength="26" formControlName="city" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Area code</mat-label>
                                    <input matInput maxlength="6" formControlName="pincode" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Province</mat-label>
                                    <input matInput maxlength="26" formControlName="region" class="col-10"
                                        autocomplete="off" cityId>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-xl-12  mt-4 d-flex justify-content-end button-style">
                            <button class="btn btn-secondary mr-3" (click)="addresschange()">
                                Submit
                            </button>
                        </div>
                    </form>
                </ng-container>
                <div *ngIf="disaplayType=='print'">
                    <div class="pdf-height">
                        <iframe class="pdfobject" title="Embedded PDF" width="100%" height="800px" [src]="sanitizedUrl">
                        </iframe>
                    </div>
                </div>

            </form>
            <form [formGroup]="physicaladdressform" *ngIf="disaplayType=='physicaladdress'">
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4" *ngIf="physicaladdressform.value.unitNumber">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Unit Number</mat-label>
                            <input matInput formControlName="unitNumber" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4" *ngIf="physicaladdressform.value.complexName">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Complex</mat-label>
                            <input matInput formControlName="complexName" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Street No</mat-label>
                            <input matInput formControlName="streetNumber" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Street Name</mat-label>
                            <input matInput formControlName="streetName" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Suburb</mat-label>
                            <input matInput formControlName="suburb" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Postal Code</mat-label>
                            <input matInput formControlName="postalCode" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Province</mat-label>
                            <input matInput formControlName="province" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Country Code</mat-label>
                            <input matInput formControlName="countryCode" class="col-10" autocomplete="off" cityId>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12  mt-4 d-flex justify-content-center button-style">
                        <button class="btn btn-secondary mr-3" (click)="physicaladdresssave()">
                            Yes
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            No
                        </button>
                    </div>
                </div>
            </form>
        </div>

    </div>

</div>